import About from "./About/About";
import Contact from "./Contact/Contact";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";
import Project from "./Project/Project";
import Service from "./Service/Service";

function App() {
  return (
   <>
   <Header/>
   <About/>
   <Service/>
   <Project/>
   <Contact/>
   <Footer/>
   </>
    
  );
}

export default App;
